var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":_vm.popupWidth,"value":_vm.vModel,"fullscreen":_vm.fullView}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }